import React, { useState } from 'react'
import Img from 'gatsby-image'
import ImageModal from './ImageModal'

const SplitImageRight = ({ data, isFrontPage }) => {
    const { top, bottom, title, content, button, bottomImage, image } = data

    const [showImage, setShowImage] = useState(false);
    const [photo, setPhoto] = useState();

    const handleShowImageModal = (image) => {
        setShowImage(!showImage);
        setPhoto(image)
    }

    return (
        <section className="split-image-right">
            <div className="left">
                {top ? (
                    <div className="content-wrapper">
                        <h5>{top.title}</h5>
                        <div dangerouslySetInnerHTML={{ __html: top.content }}></div>
                        {top.button && (
                            <a className="btn button-solid" href={top.button.url}>{top.button.title}</a>
                        )}
                    </div>
                ) : (
                    <div className="content-wrapper">
                        <h5>{title}</h5>
                        <div dangerouslySetInnerHTML={{ __html: content }}></div>
                        {button && (
                            <a className="btn button-solid" href={button.url}>{button.title}</a>
                        )}
                    </div>
                )}
                {bottom ? (
                    <div className="content-wrapper">
                        <h5>{bottom.title}</h5>
                        <div dangerouslySetInnerHTML={{ __html: bottom.content }}></div>
                        {bottom.button && (
                            <a className="btn button-solid" href={bottom.button.url}>{bottom.button.title}</a>
                        )}
                    </div>
                ) : null}
                {bottomImage ? (
                    <div className="image-wrapper">
                        <Img 
                            fluid={bottomImage?.localFile?.childImageSharp?.fluid}
                            objectFit="contain"
                        />
                    </div>
                ) : null}
            </div>
            {image && (
                <div className="right">
                    {isFrontPage ? (     
                        <a onClick={(e) => handleShowImageModal(image)}>
                            <div className="image-wrapper">
                                <Img 
                                    fluid={image?.localFile?.childImageSharp?.fluid}
                                />
                            </div>
                        </a>   
                    ) : (
                        <div className="image-wrapper">
                            <Img
                                fluid={image?.localFile?.childImageSharp?.fluid}
                            />
                        </div>
                    )}
                </div>
            )}
            <ImageModal showImage={showImage} hide={handleShowImageModal} photo={image} />
        </section>            
    )
}

export default SplitImageRight
